<style lang="scss" scoped>
.tag {
  border-radius: 15px;
  display: inline-flex;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
  height: 25px;
  &.selected {
    background: var(--primary);
    color: #fff;
  }
}
</style>
<template>
  <div>
    <h6 class="fs-17 fw-b mt-15 mb-15">{{ $t('general.object.filter') }}</h6>

    <!-- Tags-->
    <p class="fs-15 fw-b text-body-light mb-15">{{ $t('general.object.categories') }}</p>
    <div class="tags el-tags mb-30">
      <template v-if="Object.keys(value.tags).length">
        <div class="tag c-pointer mr-5" :class="{ selected: value }" v-for="(value, tag, index) in value.tags" :key="index" @click="toggleTag(tag)">
          <i class="fal fa-tag fs-10 mr-5"></i>
          <span>{{ tag }}</span>
        </div>
      </template>
      <div v-else class="empty-tag tag fs-11">{{ $t('general.object.no_categories') }}</div>
    </div>

    <!-- Files-->
    <p class="fs-15 fw-b text-body-light mb-15">{{ $t('general.object.files') }}</p>
    <div class="files d-flex flex-wrap">
      <template v-if="Object.keys(value.files).length > 0">
        <el-file-icon class="mr-10 c-pointer can-select mb-10" size="xlarge" :class="{ selected: value }" @click="toggleFile(file)" v-for="(value, file, index) in value.files" :key="index" :file="file"></el-file-icon>
      </template>
      <div v-else class="empty-tag tag fs-11">{{ $t('general.object.no_files') }}</div>
    </div>
  </div>
</template>

<script>
import { ElFileIcon } from '@/components/elements/_index';

export default {
  name: 'views.object.partials.filter',

  components: { ElFileIcon },

  props: {
    value: {
      type: Object,
      required: false,
      default: () => {
        return {
          files: {},
          tags: {},
        };
      },
    },
  },

  methods: {
    toggleTag(tag) {
      this.value.tags[tag] = !this.value.tags[tag];
      this.$emit('input', this.value);
    },
    toggleFile(file) {
      this.value.files[file] = !this.value.files[file];
      this.$emit('input', this.value);
    },
  },
};
</script>
